import { useState } from "react";
import { Link } from "react-router-dom";
import { useMe } from "../App";
import { useApi } from "../lib/api";
import { Badge, Card, Empty, ErrorNote, fmtDate, Loading, Table, Td } from "../components/ui";

export default function Outbox() {
  const { me } = useMe();
  const { data, error, loading } = useApi<any>("/outbox");
  const [open, setOpen] = useState<string | null>(null);
  const [tab, setTab] = useState<"mail" | "sf">("mail");
  if (loading && !data) return <Loading />;
  return (
    <div className="space-y-4">
      <h1 className="text-[1.45rem] font-semibold tracking-tight">Outbox</h1>
      <p className="text-sm text-muted">Every email the sender handled, kept 90 days: dry-run (recorded only), test (sent to the test mailbox) or live (sent to the prospect).</p>
      <ErrorNote error={error} />
      {me.isAdmin && (
        <div className="flex gap-2 text-sm">
          <button className={`rounded-full px-3 py-1 ${tab === "mail" ? "bg-accent text-accent-ink" : "bg-surface ring-1 ring-line"}`} onClick={() => setTab("mail")}>Emails ({data?.mail.length ?? 0})</button>
          <button className={`rounded-full px-3 py-1 ${tab === "sf" ? "bg-accent text-accent-ink" : "bg-surface ring-1 ring-line"}`} onClick={() => setTab("sf")}>Salesforce queue ({data?.sf.length ?? 0})</button>
        </div>
      )}
      {tab === "mail" ? (
        <Card>
          {!data?.mail.length ? <Empty>No emails sent yet.</Empty> : (
            <ul className="divide-y divide-line">
              {data.mail.map((m: any) => (
                <li key={m.id} className="py-2">
                  <button className="w-full text-left" onClick={() => setOpen(open === m.id ? null : m.id)}>
                    <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
                      <span><b>{m.subject}</b> <span className="text-muted">→ {m.to}</span></span>
                      <span className="flex items-center gap-2 text-xs text-muted"><Badge tone={m.mode}>{m.mode}</Badge>{fmtDate(m.at)}</span>
                    </div>
                  </button>
                  {open === m.id && (
                    <div className="mt-2 rounded-lg bg-surface-2 p-3 text-sm">
                      <div className="mono text-xs text-muted">From: {m.from}<br />To: {m.to}<br />Delivered to: {m.deliveredTo}<br />Message-ID: {m.messageId}{m.inReplyTo && <><br />In-Reply-To: {m.inReplyTo}</>}</div>
                      <div className="mail mt-2">{m.body}</div>
                      <Link className="mt-2 inline-block text-xs text-accent-text hover:underline" to={`/campaigns/${m.campaignId}/contacts/${m.contactId}`}>Open sequence</Link>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </Card>
      ) : (
        <Card title="Salesforce writes (queued until the integration user is connected)">
          {!data?.sf.length ? <Empty>Nothing queued.</Empty> : (
            <Table head={["When", "Operation", "Payload", "Status"]}>
              {data.sf.map((s: any) => (
                <tr key={s.id}>
                  <Td className="whitespace-nowrap text-muted">{fmtDate(s.at)}</Td>
                  <Td className="mono text-xs">{s.op}</Td>
                  <Td className="mono max-w-md truncate text-xs">{JSON.stringify(s.payload)}</Td>
                  <Td><Badge tone="queued">{s.status}</Badge></Td>
                </tr>
              ))}
            </Table>
          )}
        </Card>
      )}
    </div>
  );
}
